import { useRef, useEffect, useState } from "react";
import * as THREE from "three";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import Navbar from "../../Components/Navbar/Navbar";
import "./LandingPage.css"
import axios from "axios";
import { useTimer } from 'react-timer-hook';
const LandingPage = () => {
  // const mountRef = useRef(null);
  const [clockTime, setClockTime] = useState(true);
  const [time, setTime] = useState(new Date());
  // useEffect(() => {
  //   ;
  //   //Data from the canvas
  //   const currentRef = mountRef.current;
  //   const { clientWidth: width, clientHeight: height } = currentRef;

  //   //Scene, camera, renderer
  //   const scene = new THREE.Scene();
  //   const clock = new THREE.Clock();
  //   const camera = new THREE.PerspectiveCamera(10, width / height, 0.2, 100);
  //   scene.add(camera);
  //   camera.position.set(-9, 4, 10);
  //   camera.lookAt(new THREE.Vector3());

  //   const renderer = new THREE.WebGLRenderer();
  //   renderer.setSize(width, height);
  //   scene.background = new THREE.Color(0x0A0F15);
  //   currentRef.appendChild(renderer.domElement);

  //   //Resize canvas
  //   const resize = () => {
  //     renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
  //     camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
  //     camera.updateProjectionMatrix();
  //   };
  //   window.addEventListener("resize", resize);
  //   var mixer;
  //   //Animate the scene
  //   const animate = () => {
  //     var delta = clock.getDelta();
  //     if (mixer) mixer.update(delta);
  //     renderer.render(scene, camera);
  //     requestAnimationFrame(animate);
  //   };
  //   animate();

  //   //gltf loader
  //   const person = new GLTFLoader();
  //   person.load(
  //     "/AnonymousAnimado.gltf", (gltf) => {
  //       gltf.scene.scale.set(0.1, 0.1, 0.1);
  //       gltf.scene.position.set(0, -0.1, 0);
  //       scene.add(gltf.scene);
  //       mixer = new THREE.AnimationMixer(gltf.scene);
  //       gltf.animations.forEach((clip) => {
  //         mixer.clipAction(clip).play();

  //       });
  //     },
  //     (xhr) => {
        
  //     },
  //     (error) => {
  //       console.error(error);
  //     }
  //   );
  //   //Lights
  //   const ambientalLight = new THREE.AmbientLight(0xffffff, 1);
  //   scene.add(ambientalLight);
  //   const pointLight = new THREE.PointLight(0xffffff, 1)
  //   const pointLight2 = new THREE.PointLight(0xffffff, 1);
  //   pointLight.position.set(7, 7, -70);
  //   pointLight2.position.set(-10, 10, 100);
  //   scene.add(pointLight, pointLight2);
  //   return () => {
  //     window.removeEventListener("resize", resize);
  //     currentRef.removeChild(renderer.domElement);
  //   };
  // }, []);
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settings/getTimers`).then(res => {
     
      if (res.data.totalSeconds > 0) {
        if (res.data.notStart) {
          if (res.data.showTime == 'true') {
            time.setSeconds(time.getSeconds() + res.data.totalSeconds);
            setClockTime(true);
          }
          else {
            time.setSeconds(0);
            setClockTime(false);
          }

        }
        else {
          time.setSeconds(0);
          setClockTime(false);
        }
      }
      else {
        time.setSeconds(0);
        setClockTime(false);
      }

    })
  }, [])
  function MyTimer({ expiryTimestamp, showTime }) {
    const {
      seconds,
      minutes,
      hours,
      days,
    } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });


    return (
      <div className={ showTime ? "timer visible" : "timer displayNone"} >
        <div className="time-card-begin-landing">{days}<div className="time-desc-landing">días</div></div>
        <div className="time-card-landing">{hours}<div className="time-desc-landing">horas</div></div>
        <div className="time-card-landing">{minutes}<div className="time-desc-landing">minutos</div></div>
        <div className="time-card-landing">{seconds}<div className="time-desc-landing">segundos</div></div>
      </div>
    );
  }
  return (
    <div>
      <Navbar />
      <div className="landing-page">
        <div className="squares square1" /><div className="squares square2" /><div className="squares square3" /><div className="squares square4" />
        <div className="content-left ">
          <div className="content-inside-left">
            <h2>UDLA CTF</h2>
            <h3>Ingeniería en Ciberseguridad</h3>
            <div className="icons">
              <a href='https://www.udla.edu.ec/'><i className="fas fa-university icon-size" ></i></a>
              <a href='https://www.facebook.com/udlaciberseguridad'><i className="fab fa-facebook-square icon-size"></i></a>
              <a href='https://www.instagram.com/udlaciberseguridad/'><i className="fab fa-instagram icon-size"></i></a>
            </div>
          </div>
        </div>
        <div id="right-container" className="content-right">
          <div
            className='Contenedor3D divStylingLanding'
            
            // ref={mountRef}
          >
          </div>
          <div className="counterCTF" >
            <MyTimer expiryTimestamp={time} showTime={clockTime} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
